import { graphql } from "react-relay";
import { CalendarStatus } from "@components/calendar-status";
import { CalendarTimeZone } from "@components/calendar-time-zone";
import { TeammateHealthAvatar } from "@components/teammate-health-avatar";

export const teammateAnalyticsCardFragments = {
  org: graphql`
    fragment TeammateAnalyticsCard_org on Org {
      id
      experiments
      ...TeammateHealthAvatar_org
    }
  `,
  calendarFocusTimeScore: graphql`
    fragment TeammateAnalyticsCard_calendarFocusTimeScore on CalendarFocusTimeScore {
      ...TeammateHealthAvatar_calendarFocusTimeScore
      calendarId
      busyMinutes
      focusMinutes
      totalMinutes
      crawledStatus
    }
  `,
  person: graphql`
    fragment TeammateAnalyticsCard_person on Person {
      ...CalendarStatus_person
      ...CalendarTimeZone_person
      ...TeammateHealthAvatar_person
      isUser
      primaryEmail
      profile {
        givenName
        familyName
        externalImageUrl
      }
    }
  `,
  orgPerson: graphql`
    fragment TeammateAnalyticsCard_orgPerson on OrgPerson {
      userId
      personId
      primaryCalendarId
      profile {
        givenName
        familyName
        externalImageUrl
      }
      isYou
    }
  `,
  calendarStatus: graphql`
    fragment TeammateAnalyticsCard_calendarStatus on CalendarStatus {
      ...CalendarStatus_calendarStatus
    }
  `,
  profileTimeZone: graphql`
    fragment TeammateAnalyticsCard_profileTimeZone on ProfileTimeZone {
      timeZone
      ...CalendarStatus_profileTimeZone
      ...CalendarTimeZone_profileTimeZone
    }
  `,
  currentUserTimeZone: graphql`
    fragment TeammateAnalyticsCard_currentUserTimeZone on ProfileTimeZone {
      timeZone
    }
  `,
};
